import {axiosNodeClient} from "../http";

export const messageLogServiceNode = {
    totalSentPaid
}

function totalSentPaid() {
    return axiosNodeClient.get('/message/log/total-sent-paid');
}
